import { createRouter, createWebHashHistory, RouteRecordRaw, RouterView } from 'vue-router'
import { useAuthService } from '@/services/auth-service'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/cart',
        component: RouterView,
        children: [{
            path: 'login',
            name: 'login',
            component: () => import('@/views/LoginView.vue'),
        },
        {
            path: 'register',
            name: 'register',
            component: () => import('@/views/RegisterView.vue')
        },
        {
            path: 'password-reset',
            name: 'password-reset',
            component: () => import('@/views/PasswordResetView.vue')
        },
        {
            path: 'checkout',
            name: 'checkout',
            component: () => import('@/views/cart/CheckoutView.vue')
        },
        {
            path: 'quote-request',
            name: 'quote-request',
            component: () => import('@/views/cart/QuoteRequestView.vue')
        },
        {
            path: 'contract-pricing',
            name: 'contract-pricing',
            component: () => import('@/views/cart/ContractPricingView.vue')
        },
        {
            path: 'print',
            name: 'print',
            component: () => import('@/views/cart/PrintCartView.vue')
        },
        {
            path: '',
            name: 'cart',
            component: () => import('@/views/cart/CartView.vue')
        }],
    },
    {
        path: '',
        name: 'default',
        redirect: 'cart'
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

const noAuthRoutes: (string | null | undefined)[] = [
    'login',
    'register',
    'password-reset',
]

router.beforeEach(async (to, from, next) => {
    const authService = useAuthService()
    if (!noAuthRoutes.includes(to.name?.toString()) && !(await authService.isAuth())) {
        next({
            name: 'login'
        })
    } else {
        next()
    }
})

export default router
